const Backdrop = (props) => {
  return (
    <div
      onClick={props.handelhide}
      className="fixed lg:hidden h-screen w-screen bg-black/30 backdrop-opacity-16  backdrop-blur-[1px]  left-0 top-0 "
    >
      {props.children}
    </div>
  );
};

export default Backdrop;